import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import EventSection from '../../components/event'
import Features from '../../components/Features';
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'


const EventPage =() => {
    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Our Focus'} pagesub={'Focus'}/> 
            <EventSection/>
            <Features/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default EventPage;
